// @ts-check
import { ref, computed } from 'vue';
import { useUserRole } from '@/composables/user/useUserRole';
import { usePlans } from '@/composables/plans/usePlans';
import { captureError } from '@/lib/sentry';
import HTTP from '@/utils/http';

export function useBulkSendUpsell() {
  const hasTried = ref(false);

  async function fetch() {
    hasTried.value = false;

    try {
      const response = await HTTP({
        url: 'bulk-sends/meta',
      });

      hasTried.value = response.data.data.total > 0;
    } catch (error) {
      captureError(error);
    }
  }

  fetch();

  return {
    canUpgrade: useUserRole().isSuperAdmin,
    canAccess: usePlans().hasBulkSendAccess,
    hasTried: computed(() => hasTried.value),
    refetch: fetch,
  };
}
